import type { FormDrawerProps } from '../../FormDrawer';
import { NetSuiteConfigurationFooter } from './components/NetSuiteConfigurationFooter';
import { NetSuiteConfigurationForm } from './components/NetSuiteConfigurationForm';
import { NetSuiteConfigurationFormSchema } from './NetSuiteConfigurationFormSchema';

export const ConfigureNetSuiteComponents: FormDrawerProps = {
  zodSchema: NetSuiteConfigurationFormSchema,
  ContentComponent: NetSuiteConfigurationForm,
  Footer: NetSuiteConfigurationFooter,
};
